var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import ReactCrop from 'react-image-crop';
var IMAGE_CROP_INPUT_ID = 'image-crop-file-input';
var ImageCrop = /** @class */ (function (_super) {
    __extends(ImageCrop, _super);
    function ImageCrop(props) {
        var _this = _super.call(this, props) || this;
        _this.setEditorRef = function (editor) { return (_this.editor = editor); };
        _this.handleChange = function () {
            var fileInput = document.getElementById(IMAGE_CROP_INPUT_ID);
            if (fileInput.files.length) {
                var file = fileInput.files[0];
                _this.setState({ file: file });
            }
        };
        _this.onChangeCrop = function (crop) {
            _this.setState({ crop: crop });
        };
        _this.onComplete = function (crop) { return __awaiter(_this, void 0, void 0, function () {
            var onImageChange, file, canvas, ctx, image, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        onImageChange = this.props.onImageChange;
                        file = this.state.file;
                        canvas = document.createElement('canvas');
                        canvas.width = crop.width;
                        canvas.height = crop.height;
                        ctx = canvas.getContext('2d');
                        image = new Image();
                        image.src = URL.createObjectURL(file);
                        ctx.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
                        _a = onImageChange;
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                canvas.toBlob(function (blob) { return __awaiter(_this, void 0, void 0, function () {
                                    var fileUrl;
                                    return __generator(this, function (_a) {
                                        if (!blob) {
                                            resolve(null);
                                            return [2 /*return*/];
                                        }
                                        blob.name = file.name;
                                        resolve(blob);
                                        return [2 /*return*/];
                                    });
                                }); }, 'image/jpeg');
                            })];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            file: null,
            crop: props.properties,
        };
        return _this;
    }
    ImageCrop.prototype.render = function () {
        var className = this.props.className;
        var _a = this.state, file = _a.file, crop = _a.crop;
        return (React.createElement("div", null,
            file ? (React.createElement(ReactCrop, { ref: this.setEditorRef, onChange: this.onChangeCrop, onComplete: this.onComplete, crop: crop, src: URL.createObjectURL(file), className: className })) : null,
            React.createElement("input", { id: IMAGE_CROP_INPUT_ID, type: 'file', onChange: this.handleChange })));
    };
    return ImageCrop;
}(Component));
export default ImageCrop;
//# sourceMappingURL=ImageCrop.js.map